import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

type RecordingThumbnailProps = {
  imageURL?: string;
  className?: string;
  badge?: string;
};

export function RecordingThumbnail({
  className,
  badge,
  imageURL,
}: RecordingThumbnailProps) {
  return (
    <div
      className={cn(
        "relative m-1 mb-0 aspect-video overflow-hidden rounded-xl bg-background bg-right-bottom bg-no-repeat p-4 text-center",
        className,
        imageURL ? "border-transparent" : "border border-border",
      )}
    >
      {badge && (
        <Badge variant="primary" className="absolute left-2 top-2 z-10">
          {badge}
        </Badge>
      )}

      {imageURL ? (
        <img
          src={imageURL}
          alt=""
          className="absolute inset-0 transition-transform duration-300 group-hover:scale-125"
        />
      ) : (
        <div className="absolute inset-0 bg-recording bg-right-bottom bg-no-repeat transition-transform duration-300 group-hover:scale-125" />
      )}

      <div className="relative z-10 flex h-full flex-col"></div>
    </div>
  );
}
